import Axios from 'axios';
import Serve from '../app/serve';

async function getLojas() {
  const app = Serve();
  let lojas = [];

  await Axios.get(app + 'listar_lojas', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    }
  }).then(res => {
    if (res !== undefined) {
      if (res.data.status && (res.data.status === 498 || res.data.status === 401)) {
        //localStorage.clear();
      } else {
        lojas = res.data.data;

      }
    }
  })

  return lojas;
};

export default getLojas;